<div [ngClass]="isBlueEditor ? 'blue-editor' : 'editor'">
  @if (mode != 'view'&& showEditorMenu) {
  <div class="editor__menu">
    <ngx-editor-menu [editor]="editor" (click)="onEditDescription()" [toolbar]="toolbar"> </ngx-editor-menu>
  </div>
  }
  <ngx-editor
    style="min-height: 180px"
    class="w-full"
    [formControl]="name"
    [editor]="editor"
    (click)="onEditDescription()"
    [placeholder]="mode == 'view' ? '---' : ''"
  >
  </ngx-editor>
</div>
<!-- @if (showToggle || isBlueEditor ? showToggle || isBlueEditor : requiredSaveEditButton && saveValueInDb != formControlValue) {
<form [formGroup]="itemsToSetup">
  <div class="flex" style="margin-bottom: 16px">
    <mat-slide-toggle
      style="color: #25508e; font-family: Open Sans; font-style: normal; font-weight: 600; font-size: 14px; margin: 12px 0px 0px 0px"
      class="margin-zero array-item-title section-lable"
      formControlName="descriptionSection"
      (change)="onChange('descriptionSection')"
    >
      Mark Description as Complete
    </mat-slide-toggle>
  </div>
</form>
} -->
